import { NgModule } from '@angular/core'
import {
  asmTranslationChunksConfig,
  asmTranslationsDe,
  asmTranslationsEn,
  asmTranslationsJa,
  asmTranslationsZh
} from '@spartacus/asm/assets'
import { AsmRootModule, ASM_FEATURE } from '@spartacus/asm/root'
import { CmsConfig, FeaturesConfigModule, I18nConfig, provideConfig } from '@spartacus/core'

@NgModule({
  declarations: [],
  imports: [AsmRootModule, FeaturesConfigModule],
  providers: [
    provideConfig({
      featureModules: {
        [ASM_FEATURE]: {
          module: () => import('../../../features/asm/eb-asm.module').then(m => m.EbAsmModule)
        }
      }
    } as CmsConfig),
    provideConfig({
      i18n: {
        resources: {
          en: asmTranslationsEn,
          ja: asmTranslationsJa,
          de: asmTranslationsDe,
          zh: asmTranslationsZh
        },
        chunks: asmTranslationChunksConfig
      }
    } as I18nConfig)
  ]
})
export class AsmFeatureModule {}
